import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=392635fa&scoped=true&"
import script from "./addressList.vue?vue&type=script&lang=js&"
export * from "./addressList.vue?vue&type=script&lang=js&"
import style0 from "./addressList.vue?vue&type=style&index=0&id=392635fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392635fa",
  null
  
)

export default component.exports